module.exports = __webpack_public_path__ + "assets/img/config-table-5f1f6189.png";